import React from "react";
import useSecureMediaUrl from "hooks/useSecureMediaUrl";

/**
 * Drop-in image that loads via authenticated secure-uploads API (blob URL).
 */
const SecureMediaImg = ({
  src,
  alt = "",
  className,
  style,
  enabled = true,
  fallback = null,
  ...rest
}) => {
  const { blobUrl, isLoading, error } = useSecureMediaUrl(src, { enabled });

  if (!enabled || !src) {
    return fallback;
  }

  if (isLoading) {
    return (
      fallback || (
        <div
          className={className}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 40,
            ...style,
          }}
        >
          <span className="spinner-border spinner-border-sm" role="status" />
        </div>
      )
    );
  }

  if (error || !blobUrl) {
    return fallback;
  }

  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
      style={style}
      {...rest}
    />
  );
};

export default SecureMediaImg;
